import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
const Card: React.FC<CardProps> = ({
  children,
  className = '',
  onClick
}) => {
  return <div className={`bg-white rounded-lg shadow-sm border border-gray-200 ${className} ${onClick ? 'cursor-pointer hover:shadow-md transition-shadow' : ''}`} onClick={onClick} data-id="element-11680">
      {children}
    </div>;
};
export default Card;